/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { Grid, withStyles } from '@material-ui/core';
import {
    arrayOf, node, object, shape, string,
} from 'prop-types';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useUIDSeed } from 'react-uid';
import validateEmailAddress from '../../../../helpers/validateEmailAddress';
import LinkOrATag from '../../GraphqlCommonComponents/LinkOrATag/LinkOrATag';

const styles = (theme) => ({
    container: {
        justifyContent: 'space-between',
        marginTop: '20px',
        padding: '0 5%',
    },
    bottomBlock: {
        padding: '0 10px',
        marginBottom: 7,
        [theme?.breakpoints?.down('476')]: {
            padding: 'inherit',
        },
        '& a': {
            textDecoration: 'underline !important',
            display: 'block',
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
        '& p': {
            margin: '2px 0',
            fontSize: 14,
            lineHeight: '25px',
            wordBreak: 'break-all',
        },
        '& h3': {
            margin: 0,
            textTransform: 'uppercase',
            lineHeight: '50px',
            [theme?.breakpoints?.down('600')]: {
                lineHeight: '30px',
            },
        },
    },
});

const LinkOrReference = ({ href, children }) =>  {
    if (validateEmailAddress(href)) {
        return <a href={`mailto:${href}`}>{children}</a>;
    }
    return <LinkOrATag href={href}>{children}</LinkOrATag>;
};

LinkOrReference.propTypes = {
    href: string.isRequired,
    children: node.isRequired,
};

const CopyGrid = ({
    blocks,
    classes,
}) => {
    if (!blocks?.length) return null;

    const seed = useUIDSeed();
    const getBlocksInColumns = () => {
        const columns = [[], []];
        blocks.forEach((block, index) => {
            if (index < (blocks.length / 2)) {
                columns[0].push(block);
            } else {
                columns[1].push(block);
            }
        });
        return columns;
    };

    return (
        <Grid container>
            {getBlocksInColumns().map((column) => (
                <Grid key={seed(column)} item xs={6} className={classes.container}>
                    {column.map((data) => {
                        const {
                            heading, copy,
                        } = data;
                        return (
                            <Grid
                                key={seed(data)}
                                className={classes.bottomBlock}
                            >
                                <h3>{heading} </h3>
                                <ReactMarkdown
                                    renderers={{
                                        linkReference: LinkOrReference,
                                    }}
                                    source={copy}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            ))}
        </Grid>
    );
};

CopyGrid.propTypes = {
    blocks: arrayOf(shape({
        heading: string,
        copy: string,
    })).isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(CopyGrid);
